export default __webpack_public_path__ + "static/media/goad.8b33ad1c.png";